<template>
  <div class="app-wrapper">
    <div id="app-menu" class="app-l">
      <menu-title :is-dark="isDark" />
      <menu-left />
    </div>
    <div class="app-r">
      <navbar @showAIChat="onShowAIChat"/>
      <app-main />
    </div>
    <chat-robot :dialog-visible.sync="dialogVisible"></chat-robot>
  </div>
</template>

<script>
import { Navbar, AppMain, MenuTitle, MenuLeft } from './components'
import { mapState } from 'vuex'
import ChatRobot from '../chatrobot'

export default {
  name: 'Layout',
  components: {
    Navbar,
    AppMain,
    MenuTitle,
    MenuLeft,
    ChatRobot
  },
  data() {
    return {
      isDark: false,
      dialogVisible: false
    }
  },
  computed: {
    ...mapState({
      themeName: state => state.app.themeName,
      breadListState: index => index.app.breadListState
    }),
    isShow() {
      const { breadListState } = this
      return breadListState?.length > 1
    }
  },
  watch: {
    '$store.state.app.themeName'(newValue) {
      newValue === 'darkTheme' ? (this.isDark = true) : (this.isDark = false)
    }
  },
  mounted() {
    // 隐藏页面加载动画
    document.getElementById('page-preloading').style.display = 'none'
    this.themeName === 'darkTheme' ? (this.isDark = true) : (this.isDark = false)
    this.getPersonConfigFn()
  },
  methods: {
    getPersonConfigFn() {
      this.$apis.configmanage.getPersonConfig().then(res => {
        let themeName = 'darkTheme'
        res.data.backGround == 'darkTheme'
          ? (themeName = 'darkTheme')
          : (themeName = 'defaultTheme')
        localStorage.setItem('cbaas_system_theme', themeName)
        this.$store.dispatch('updateTheme', themeName)
        document.body.className = themeName
        localStorage.setItem('cbaas_system_isDecode', res.data.txValueDecode)
        this.$store.dispatch('updateDecode', res.data.txValueDecode)
      })
    },
    onShowAIChat(){
      this.dialogVisible = true;
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('app-wrapper', (
  --app-menu-bg-color: #232D51,
  --app-menu-box-shadow-color: rgba(92, 226, 255, 0.25)
), (
  --app-menu-bg-color: #fff,
  --app-menu-box-shadow-color: transparent
));
.app-wrapper {
  @include adaptation((
    --app-menu-box-shadow: -4px 5px 17px 0px,
  ));
  
  display: flex;
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;

  .app-l {
    width: var(--base-menu-width);
    background-color: var(--app-menu-bg-color);
    box-shadow: var(--app-menu-box-shadow) var(--app-menu-box-shadow-color) inset;
    z-index: 400;
  }
  .app-r {
    width: calc(100vw - var(--base-menu-width));
  }
}
</style>
